import React                      from 'react'
import { Select }                 from 'antd'
import { SelectProps }            from 'antd/lib/select'
import { Observer }               from 'mobx-react'

import { CTE }                    from '../01_core'
import { FACTORY
       , MApp }                   from '../09_model_app'

export const SelectMKSType: React.FC< SelectProps> = ( props ) =>
<Observer render={ ( ) => 
{
  const user  = MApp( ).user
      , { value, ...rest } = props
      , machines = FACTORY.MKS_TYPES.data_for( { cloud_id: user!.workgroup.cloud.id
                                           , workgroup_id: user!.workgroup.id }
                                         , 0 ) ;

  return <Select loading={ machines.loading } value={ value === CTE.ENUM_NON_SELECTED? '' : value } {...rest}>
            { machines.data.map( mac =>
               <Select.Option value={mac.id} key={ mac.id }>{ mac.name }</Select.Option>
            ) }
         </Select>
} } /> ;
